import axios from 'axios'
import i18n from '../plugins/i18n'

export default {
  getNpaStageData (id) {
    return axios.get(`${i18n.locale}/api/npa/${id}/npaStagesData`)
  },

  saveNpaStage (id, data) {
    return axios.post(`${i18n.locale}/api/npa/${id}/addNpaStage`, data)
  },

  getFilterFormData () {
    return axios.get(`${i18n.locale}/api/npa/filterFormData`)
  },

  getList (params) {
    let param = ''

    for (let field in params) {
      param += `${field}=${params[field]}&`
    }

    return axios.get(`${i18n.locale}/api/npa/profileNpa?${param}`)
  },

  getComments (sorting) {
    let sort = ''

    for (let field in sorting) {
      sort += `${field}=${sorting[field]}&`
    }

    return axios
      .get(`${i18n.locale}/api/npaComment/profile/?${sort}`)
      .then((response) => {
        return Promise.resolve(response.data)
      })
  },

  getComplaints (page) {
    return axios
      .get(`${i18n.locale}/api/npaComment/profileCommentComplaint?page=${page}`)
      .then((response) => {
        return Promise.resolve(response.data)
      })
  },

  getCommentAnswers (sorting) {
    let sort = ''

    for (let field in sorting) {
      sort += `${field}=${sorting[field]}&`
    }
    return axios
      .get(`${i18n.locale}/api/npaCommentAnswer/userNpaCommentAnswers/?${sort}`)
      .then((response) => {
        return Promise.resolve(response.data)
      })
  },

  getNpaResultData (id) {
    return axios.get(`${i18n.locale}/api/npa/${id}/npaResultData`)
  },

  saveNpaResult (id, data) {
    return axios.post(`${i18n.locale}/api/npa/${id}/addNpaResult`, data)
  },

  getPortalStatistics () {
    return axios.get(`${i18n.locale}/api/public/portalStatistics`)
  },

  getPopularStatistics () {
    return axios.get(`${i18n.locale}/api/public/popularStatistics`)
  },

  getCommentStatistics (id, filters) {
    let filter = ''

    for (const field in filters) {
      filter += `${field}=${filters[field]}&`
    }

    return axios.get(`${i18n.locale}/api/public/commentStatistics/${id}?${filter}`)
  },

  exportCommentStatisticsExcel (id, filters) {
    let filter = ''

    for (const field in filters) {
      filter += `${field}=${filters[field]}&`
    }

    return axios.get(`${i18n.locale}/api/public/commentStatistics/${id}/export/excel?${filter}`, {
      responseType: 'blob'
    })
  },

  pdfPrint(id) {
    return axios.get(`${i18n.locale}/api/public/search/pdf-print/${id}`, { responseType: 'arraybuffer' })
  },

  getNpaPromotionHistoryFormData(id) {
    return axios.get(`${i18n.locale}/api/npaPromotionHistory/getNpaPromotionHistoryFormData/${id}`)
  },

  getEdit(id) {
    return axios.get(`${i18n.locale}/api/npaPromotionHistory/getEdit/${id}`)
  },

  createNpaPromotionHistory(id, formData) {
    return axios.post(`${i18n.locale}/api/npaPromotionHistory/createNpaPromotionHistory/${id}`, formData)
  },

  updateNpaPromotionHistory(id, formData) {
    return axios.patch(`${i18n.locale}/api/npaPromotionHistory/editNpaPromotionHistory/${id}`, formData)
  },

  getNpaPromotionHistoryList(id) {
    return axios.get(`${i18n.locale}/api/npaPromotionHistory/getNpaPromotionHistoryList/${id}`)
  },

  deleteNpaPromotionHistory(id) {
    return axios.delete(`${i18n.locale}/api/npaPromotionHistory/deleteNpaPromotionHistory/${id}`)
  },

  getNpaPromotionHistoryDocumentList(id) {
    return axios.get(`${i18n.locale}/api/npaPromotionHistory/getNpaPromotionHistoryDocumentList/${id}`)
  },

  deleteNpaPromotionHistoryDocument(id) {
    return axios.delete(`${i18n.locale}/api/npaPromotionHistory/deleteNpaPromotionHistoryDocument/${id}`)
  },

  createNpaPromotionHistoryDocument(id, formData) {
    return axios.post(`${i18n.locale}/api/npaPromotionHistory/createNpaPromotionHistoryDocument/${id}`, formData)
  },

  getNpaHistoryChangeList(id) {
    return axios.get(`${i18n.locale}/api/npaFieldHistory/getNpaFieldHistoryList/${id}`)
  },

  getNpaFieldHistoryInfo(id) {
    return axios.get(`${i18n.locale}/api/npaFieldHistory/getNpaFieldHistoryInfo/${id}`)
  },

  getDataFromNpaById(id) {
    return axios.get(`${i18n.locale}/api/npa/getDataFromNpaById/${id}`)
  },
}
